import { OrderStatus } from '@/models/order.model';
import { IPaginationDTO, IPaginationResponse } from '@/models/pagination.model';
import { StepType } from '@/models/step.model';
import { PropertyType } from './property.model';

export enum LogsEndpoints {
  ROOT = '/action-logs',
}

export const getLogsEndpoints = ({ id, entityType }: { id: string; entityType: EntityType }) => ({
  GET_ACTION_LOGS: `${LogsEndpoints.ROOT}/${entityType}/${id}`,
});

export enum EntityType {
  ORDER = 'order',
  PROPERTY = 'property',
}

export enum Initiator {
  USER = 'user',
  ADMIN = 'admin',
  SYSTEM = 'system',
}

export enum Action {
  ORDER_CREATED = 'order_created',
  ORDER_COMPLETED = 'order_completed',
  ORDER_STATUS_UPDATED = 'order_status_updated',
  ORDER_FILE_UPLOADED = 'order_file_uploaded',
  ORDER_FILE_REMOVED = 'order_file_removed',
  ORDER_PHOTO_UPLOADED = 'order_photo_uploaded',
  ORDER_PHOTO_REMOVED = 'order_photo_removed',
  PROPERTY_FILE_UPLOADED = 'property_file_uploaded',
  PROPERTY_FILE_REMOVED = 'property_file_removed',
  PROPERTY_DATA_AMENDED = 'property_data_amended',
  STEP_RESET = 'step_reset',
}

export interface IDiffState {
  file_name?: string;
  photos_count?: number;
  status?: OrderStatus;
  bra?: number;
  property_type?: PropertyType;
}

export interface IBaseActionLog {
  PK: string;
  SK: string;
  action: Action;
  step_name?: StepType;
  initiator: Initiator;
  initiator_id?: string;
  initiator_name?: string;
  initiator_email?: string;
  diff?: {
    old?: IDiffState;
    new?: IDiffState;
  };
  created: string;
  modified: string;
}

// ----------------- DTOs ----------------

export interface IGetActionLogsDTO extends IPaginationDTO {
  id: string;
  entityType: EntityType;
}

// ------------ Responses --------------

export interface IGetActionLogsResponse {
  items: IBaseActionLog[];
  cursor: IPaginationResponse;
}
